import { get } from 'lodash';
import 'jquery-serializejson';

import { toast } from '@hivebrite/design-system/Toast';

import { HtmlContent } from 'hb-react/shared/components/HtmlContent';

const generateToastId = (message, type) => {
  let messageKey;

  if (typeof message === 'string') {
    messageKey = message;
  } else {
    try {
      messageKey = JSON.stringify(message);
    } catch {
      messageKey = `non-serializable-${Date.now()}`;
    }
  }

  return `${type}-${messageKey.slice(0, 100)}`;
};

/* ------------------------------------- */
// Error display
/* ------------------------------------- */
// TO CHECK
export const displayXhrError = (response) => {
  try {
    const message = get(response, 'response.data');
    toast.error(<HtmlContent content={message} />, {
      id: generateToastId(message, 'error'),
      duration: 10000,
    });
    // eslint-disable-next-line no-empty
  } catch (_err) {}
};

export const scrollTop = () =>
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });

export const getFormData = (data) =>
  // eslint-disable-next-line no-undef, eqeqeq
  data != undefined ? $(data).serializeJSON() : {};

export const getMainContainerWidth = (data) => (data ? data.clientWidth : null);

export const htmlToString = (htmlString) =>
  // eslint-disable-next-line eqeqeq
  htmlString != undefined
    ? htmlString
        .replace(/<(head|link|meta|script|style|title|figcaption)[^<]+/g, '')
        .replace(/<[^>]+>/g, '')
    : '';
